<template lang="pug">
    .landingpage
        .element(v-if="sections.length" v-for="(section, index) in sections" :key="section.id" :class="section.key")
            Heading(v-if="section.key === 'heading'" :section="section")
            ImageSection(v-if="section.key === 'image'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
            Video(v-if="section.key === 'video'" :section="section")
            Slider(v-if="section.key === 'slider'" :section="section")
            PhotoAlbum(v-if="section.key === 'photoalbum'" :section="section")
            Downloads(v-if="section.key === 'downloads'" :section="section")
            Audio(v-if="section.key === 'audio'" :section="section")
            Map(v-if="section.key === 'map'" :section="section")
            MapBox(v-if="section.key === 'mapbox'" :section="section")
            CategoryPosts(
                v-if="section.key === 'categoryposts'"
                :section="section"
                :per-page="3"
                orientation="horizontal"
            )
            DividingLine(v-if="section.key === 'dividingLine'" :section="section")
            Banners(v-if="section.key === 'banners'" :section="section") 

</template>

<script>

// import _ from 'lodash'
import { mapGetters, mapMutations } from 'vuex'

import Heading from '@/components/Heading'
import ImageSection from '@/components/ImageSection'
import Post from '@/components/Post'
import Video from '@/components/Video'
import Slider from '@/components/Slider'
import PhotoAlbum from '@/components/PhotoAlbum'
import Downloads from '@/components/Downloads'
import Audio from '@/components/Audio'
import Map from '@/components/Map'
import MapBox from '@/components/MapBox'
import CategoryPosts from '@/components/CategoryPosts'
import DividingLine from '@/components/DividingLine'
import Banners from '@/components/Banner'


export default {
    name: 'LandingPage',
    components: {
        Heading,
        ImageSection,
        Post,
        Video,
        Slider,
        PhotoAlbum,
        Downloads,
        Audio,
        Map,
        MapBox,
        CategoryPosts,
        DividingLine,
        Banners
        // SocialWall,
        // Banners,
    },
    computed: {
        ...mapGetters('currentPage', {
            sections: 'sections',
        })
    },
    methods: {
        ...mapMutations({
            updateHeaderVisibility: 'updateHeaderVisibility',
        })
    },
    mounted() {
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (viewportWidth > 1022) {
            this.updateHeaderVisibility(true);
        } else {
            this.updateHeaderVisibility(false);
        }

        window.addEventListener('resize', this.checkPerPage);
        
    }
}

</script>

<style lang="sass" scoped>
    .element
        margin: 0 15px
</style>
